export { default, getServerSideProps } from "pages/[lang]/friendship";
